export const hasBrowserAPI = (): boolean =>
  typeof window !== 'undefined' && typeof document !== 'undefined';
